export default __webpack_public_path__ + "static/media/forestly-noexpl-04_EN.f40f7d85.png";